/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { makeVar, ReactiveVar } from '@apollo/client';

// Types
import { DialogIdentifier, DialogPropsWildcard } from '../types';
import { Resource, Workspace } from '@app-types/blackroom-api';

/* -------------------------------------------------------------------------- */
/*                                Reactive var                                */
/* -------------------------------------------------------------------------- */

export interface DialogStore {
  dialogResources?: Resource[];
  dailogWorkspace?: Workspace;
  dialogIdentifier?: DialogIdentifier | null;
  dialogProps?: DialogPropsWildcard<any>;
  invokeDialog?: <Identifier extends DialogIdentifier>(
    dialogIdentifier: DialogIdentifier,
    props?: DialogPropsWildcard<Identifier>,
  ) => void;
  closeDialog?: (dialogIdentifier: DialogIdentifier) => void;
  closeAll?: () => void;
}

const dialogStore: ReactiveVar<DialogStore | undefined> = makeVar<
  DialogStore | undefined
>(undefined);

export default dialogStore;
